import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

export const analyticsApi = {
  // Track event (public)
  trackEvent: (data) =>
    axios.post(`${API}/api/analytics/event`, data, { headers: getHeaders() }).catch(() => {}),

  startSession: (sessionId) =>
    axios.post(`${API}/api/analytics/session/start`, { sessionId }, { headers: getHeaders() }).catch(() => {}),

  endSession: (sessionId) =>
    axios.post(`${API}/api/analytics/session/end`, { sessionId }, { headers: getHeaders() }).catch(() => {}),

  // Admin dashboard
  getOverview: (days = 30) =>
    axios.get(`${API}/api/analytics/dashboard/overview?days=${days}`, { headers: getHeaders() }),

  getFeatureUsage: (days = 30) =>
    axios.get(`${API}/api/analytics/dashboard/feature-usage?days=${days}`, { headers: getHeaders() }),

  getDailyTrends: (days = 30) =>
    axios.get(`${API}/api/analytics/dashboard/daily-trends?days=${days}`, { headers: getHeaders() }),

  getUsageTrend: (days = 30) =>
    axios.get(`${API}/api/analytics/dashboard/usage-trend?days=${days}`, { headers: getHeaders() }),

  getTopUsers: (days = 30, limit = 10) =>
    axios.get(`${API}/api/analytics/dashboard/top-users?days=${days}&limit=${limit}`, { headers: getHeaders() }),

  getRecentEvents: (limit = 50) =>
    axios.get(`${API}/api/analytics/dashboard/recent-events?limit=${limit}`, { headers: getHeaders() }),

  getEventTypes: (days = 30) =>
    axios.get(`${API}/api/analytics/dashboard/event-types?days=${days}`, { headers: getHeaders() }),

  getContentQuality: (days = 30) =>
    axios.get(`${API}/api/analytics/dashboard/content-quality?days=${days}`, { headers: getHeaders() }),

  getSessionStats: (days = 30) =>
    axios.get(`${API}/api/analytics/dashboard/session-stats?days=${days}`, { headers: getHeaders() }),

  getTopQuestions: (days = 30, limit = 20) =>
    axios.get(`${API}/api/analytics/dashboard/top-questions?days=${days}&limit=${limit}`, { headers: getHeaders() }),

  getWeakAnswers: (days = 30, limit = 20) =>
    axios.get(`${API}/api/analytics/dashboard/weak-answers?days=${days}&limit=${limit}`, { headers: getHeaders() }),

  getFeatureDropoff: (days = 30) =>
    axios.get(`${API}/api/analytics/dashboard/feature-dropoff?days=${days}`, { headers: getHeaders() }),

  getCategoryBreakdown: (days = 30) =>
    axios.get(`${API}/api/analytics/dashboard/category-breakdown?days=${days}`, { headers: getHeaders() }),
};
